import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Col, Row, Typography } from 'antd'

import {
  GestureLine,
  MethodCard,
  MethodTitle,
  StepList,
  TrailingParagraph
} from './styled'

// Two cards side by side, not Tabs: tabs show one case and hide the other, so whoever is unsure
// which one applies has to click to find out. The card title names the companies, because the
// reader knows the company they work for and not what is inside the sheet.
const CheckInMethods = props => {
  const { methods } = props

  return (
    <>
      <Row gutter={[16, 16]}>
        {methods.map(method => (
          <Col key={method.key} xs={24} md={12}>
            <MethodCard
              size={'small'}
              title={
                <MethodTitle>
                  {method.logos.map(logo => (
                    <img alt={''} key={logo} src={logo} />
                  ))}
                  <FormattedMessage
                    id={`help.howto.${method.key}.companies`}
                  />
                </MethodTitle>
              }>
              <GestureLine>
                <FormattedMessage id={`help.howto.${method.key}.gesture`} />
              </GestureLine>
              <StepList>
                {Array.from({ length: method.steps }, (_, i) => (
                  <li key={i}>
                    <FormattedMessage
                      id={`help.howto.${method.key}.step${i + 1}`}
                    />
                  </li>
                ))}
              </StepList>
            </MethodCard>
          </Col>
        ))}
      </Row>
      <TrailingParagraph>
        <Typography.Text strong>
          <FormattedMessage id={'help.howto.common.title'} />
        </Typography.Text>{' '}
        <FormattedMessage id={'help.howto.common.body'} />{' '}
        <FormattedMessage id={'help.howto.common.devices'} />
      </TrailingParagraph>
    </>
  )
}
CheckInMethods.propTypes = {
  methods: PropTypes.array.isRequired
}
export default CheckInMethods
